<template>
  <div>
    <slot name="title">
      <div class="tw-text-indigo-500">{{ title }}</div>
    </slot>
    <slot name="content">
      <div class="tw-text-lg">{{ content }}</div>
    </slot>
  </div>
</template>

<script setup lang="ts">
defineProps<{
  title?: string
  content?: string
}>()
</script>
